<div class="inicio">
  <form #insertForm="ngForm"  [formGroup]="formDetSolicitud" (ngSubmit)="goBack()">

      <p class="titulo">SOLICITUD DE {{tipoSolicitud}} </p>
        <div class="grid-containerB" >
          <button mat-mini-fab style="background-color: #00c030d0;  color: white;" (click)="goBack()"> <span class="material-icons">undo</span> </button>
        </div>
      <div class="grid-container2">
        <div class="celda">
            <mat-label class="label" >Tipo de solicitud</mat-label>
            <mat-form-field appearance="outline">
                <input matInput type="text" placeholder="Tipo se solicitud" formControlName="tipoSolicitud" readonly />
            </mat-form-field>
        </div>

      </div>
      <!--DATOS DEL COLABORADOR-->
      <p></p><h3>DATOS DEL COLABORADOR</h3>
      <div class="div" >
         <!--Nombre del colaborador-->
         <div class="grid-container">
          <div class="celda">
              <mat-label class="label"> Nombre del colaborador </mat-label>
              <mat-form-field appearance="outline">
                  <input matInput type="text" placeholder="Nombre del colaborador" formControlName="colaborador" readonly />
              </mat-form-field>
          </div>
         </div>
        <!--Cargo y sucursal/oficina-->
        <div class="grid-container2">
          <!--Cargo-->
          <div class="celda">
              <mat-label class="label"> Cargo </mat-label>
              <mat-form-field appearance="outline">
                <input matInput type="text" placeholder="No se encontró este campo" formControlName="puesto" readonly/>
              </mat-form-field>
          </div>

          <!--Oficina/Sucursal-->
          <div class="celda">
              <mat-label class="label"> Sucursal </mat-label>
              <mat-form-field appearance="outline">
                  <input matInput type="text" placeholder="No se encontró este campo" formControlName="sucursal" readonly />
              </mat-form-field>
          </div>
        </div>
      </div>

      <p></p>
      <div class="div">
           <!--Sustituye a-->
           <div class="grid-container"  >
            <div class="celda"  *ngIf="tipoSoliSeleccionada('ALTA DE SERVICIOS'); " >
                <mat-label class="label"> Sustituye a </mat-label>
                <mat-form-field appearance="outline">
                  <input matInput type="text" placeholder="No se encontró este campo" formControlName="sustituye_a" readonly/>
                </mat-form-field>
            </div>
          </div>
          <!--supervisor-->
          <div class="grid-container"  >
            <div class="celda"  *ngIf="tipoSoliSeleccionada('ALTA DE SERVICIOS');" >
                <mat-label class="label"> Nombre del supervisor </mat-label>
                <mat-form-field appearance="outline">
                  <input matInput type="text" placeholder="Nombre del supervisor" formControlName="supervisor" readonly/>
                </mat-form-field>
            </div>
          </div>
         <!--Reemplazo-->
         <div class="grid-container"  >
          <div class="celda"  *ngIf="tipoSoliSeleccionada('SUSPENSIÓN DE SERVICIOS');" >
              <mat-label class="label"> ¿Cuenta con reemplazo? </mat-label>
              <mat-form-field appearance="outline">
                <input matInput type="text" placeholder="¿Cuenta con reemplazo?" formControlName="reemplazo" readonly/>
              </mat-form-field>
          </div>
        </div>
        <!--Cargo y sucursal/oficina a cubrir-->
        <P></P>
        <div class="grid-container2" *ngIf="tipoSoliSeleccionada('ACTIVACIÓN DE PRIVILEGIOS') " >

          <!--Cargo-->
          <div class="celda">
              <mat-label class="label"> Cargo a cubrir </mat-label>
              <mat-form-field appearance="outline">
                <input matInput type="text" placeholder="No se encontró este campo" formControlName="puesto_a_cubrir" readonly/>
              </mat-form-field>
          </div>

          <!--Oficina/Sucursal-->
          <div class="celda">
              <mat-label class="label"> Sucursal a cubrir </mat-label>
              <mat-form-field appearance="outline">
              <input matInput type="text" placeholder="No se encontró este campo" formControlName="sucursal_a_cubrir" readonly/>
              </mat-form-field>
          </div>
        </div>

      </div>
       <!--DATOS DEL SOLICITANTE-->
       <p></p><h3>DATOS DEL SOLICITANTE</h3>
       <div class="div">
          <!--Nombre del colaborador-->
          <div class="grid-container">
           <div class="celda">
               <mat-label class="label"> Nombre del solicitante </mat-label>
               <mat-form-field appearance="outline">
                   <input matInput type="text" placeholder="No se encontró este campo" formControlName="solicitante" readonly />
               </mat-form-field>
           </div>
          </div>
         <!--Cargo y sucursal/oficina-->
         <div class="grid-container2">
           <!--Cargo-->
           <div class="celda">
               <mat-label class="label"> Cargo </mat-label>
               <mat-form-field appearance="outline">
                 <input matInput type="text" placeholder="No se encontró este campo" formControlName="puesto_solicitante" readonly />
               </mat-form-field>
           </div>

           <!--Oficina/Sucursal-->
           <div class="celda">
               <mat-label class="label"> Sucursal </mat-label>
               <mat-form-field appearance="outline">
                   <input matInput type="text" placeholder="No se encontró este campo" formControlName="sucursal_solicitante" readonly />
               </mat-form-field>
           </div>
         </div>
          <!--email-->
          <div class="grid-container"  >
           <div class="celda"   >
               <mat-label class="label"> Email </mat-label>
               <mat-form-field appearance="outline">
                 <input matInput type="text" placeholder="No se encontró este campo" formControlName="email_solicitante" readonly/>
               </mat-form-field>
           </div>
         </div>
       </div>
       <!--DATOS GNERALES DE LOS PRIVILEGIOS-->
       <p></p><h3>DATOS GENERALES</h3>
       <div class="div" >

          <div class="div">

          <!--Servicio a solicitar-->
          <div class="grid-container" *ngIf="tipoSoliSeleccionada('ACTIVACIÓN DE PRIVILEGIOS')==false" >
            <mat-label class="label"> SERVICIOS </mat-label>

               <!--Tabla-->
          <table mat-table [dataSource] = "dataSource"  class="mat-elevation-z8">
            <ng-container matColumnDef="c1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
                <td mat-cell *matCellDef="let element"> {{element.nombre_servicio}} </td>
            </ng-container>
            <ng-container matColumnDef="c2">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTATUS DEL SERVICIO </th>
              <td mat-cell *matCellDef="let element"> {{element.status_serv}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
            <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>
          </table>
          <p></p>
          <!--Fecha de asignación-->
          <div class="grid-container" *ngIf="tipoSoliSeleccionada('ALTA DE SERVICIOS'); "  >
            <mat-label class="label">Fecha de asignación</mat-label>
            <mat-form-field appearance="outline">
                <input matInput type="text" placeholder="No se encontró este campo" formControlName="fecha_planeada" readonly/>
            </mat-form-field>
          </div>
         </div>
         <P></P>
          <div *ngIf="tipoSoliSeleccionada('ACTIVACIÓN DE PRIVILEGIOS') || tipoSoliSeleccionada('SUSPENSIÓN DE SERVICIOS') "  >

            <div class="grid-container">
              <mat-label class="label">Tipo</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput type="text" placeholder="Temporal o permanente" formControlName="tipo" readonly/>
                </mat-form-field>
            </div>
            <p></p><p></p>
            <div class="grid-container" *ngIf="tipoSeleccionado('Temporal'); ">
              <mat-label class="label"> Fecha de alta - Fecha de baja </mat-label>
              <mat-form-field appearance="fill">
                <mat-label> Fecha de alta - Fecha de baja </mat-label>
                <mat-date-range-input [formGroup]="range" ><!--[rangePicker]="picker1"-->
                  <input matStartDate formControlName="fecha_alta" placeholder="Start date" readonly>
                  <input matEndDate formControlName="fecha_baja" placeholder="End date" readonly>
                </mat-date-range-input>
              </mat-form-field>

            </div>

            <div class="grid-container2">

            </div>

          </div>

          <!--Comentarios-->
          <div class="grid-container">
              <div class="celda">
                  <mat-label class="label" *ngIf="tipoSeleccionado('Temporal')==false || tipoSoliSeleccionada('SUSPENSIÓN DE SERVICIOS')==false; "  >Comentarios</mat-label>
                  <mat-label class="label" *ngIf="tipoSeleccionado('Temporal') && tipoSoliSeleccionada('SUSPENSIÓN DE SERVICIOS'); " >Motivo de la suspención temporal </mat-label>
                  <mat-form-field class="example-full-width" appearance="outline">
                      <textarea matInput placeholder="Comentarios" formControlName="comentarios" readonly></textarea>
                  </mat-form-field>
              </div>
          </div>
        </div>
      </div>
      <p></p>
      <!--Botones-->
      <div  class="wrapper"   >
        <!--Boton cancelar-->
        <button mat-raised-button  style="background-color: #00c030d0; width:350px; color: white;"  (click)="goBack()" > ACEPTAR</button>

   </div>
  </form>
</div>
